<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：修改电表档案
    -->
    <div class="bg_add">
		<div class="addMeterCode">
			<ul>
				<li><span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->户号</span>
					<el-input v-model="account" placeholder="请输入户号" style="width: 300px;" :maxlength="12" disabled></el-input>
				</li>
				<li>
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->表类型</span>
					 <el-select v-model="type" placeholder="请选择" style="width: 200px;" disabled>
					    <el-option
					      v-for="item in types"
					      :key="item.id"
					      :label="item.label"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</li>
				<li>
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->业主类型</span>
					<el-select v-model="nature" placeholder="请选择" style="width: 180px;" disabled>
					    <el-option
							v-for="item in natures"
							:key="item.num"
							:label="item.value"
							:value="item.num">
						</el-option>
					 </el-select>
				</li>
				<li>
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->计量方案</span>
					<el-select v-model="prop" placeholder="请选择" style="width: 200px;" disabled>
					    <el-option
					      v-for="item in props"
					      :key="item.id"
					      :label="item.plan_name"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</li>
				<li>
					<span class="add_Meter_Code_Name" style="text-align: center"><!--<rt style="color:red;">*</rt>-->倍率</span>
					<el-select v-model="rate" placeholder="请选择" style="width: 190px;" disabled>
					    <el-option
					      v-for="item in rates"
					      :key="item.value"
					      :label="item.value"
					      :value="item.value">
					    </el-option>
					  </el-select>
				</li>
				<li><span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->业主姓名</span>
					<el-input v-model="owner_name" placeholder="请输入业主姓名" style="width: 200px;" disabled ></el-input>
				</li>
				<li>
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->业主电话</span>
					<el-input v-model="owner_phone" placeholder="请输入业主手机号" style="width: 200px;" :maxlength="11" disabled ></el-input>
				</li>
				<li style="width: 600px;"><span class="add_Meter_Code_Name" style="width: 95px;">
					<!--<rt style="color:red;">*</rt>-->业主身份证</span>
					<el-input v-model="owner_id_number" placeholder="请输入业主身份证" style="width: 350px;" :maxlength="18" disabled ></el-input>
				</li>
				<li>
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->开户时间</span>
					<el-date-picker
				      v-model="create_time"
				      type="datetime"
				      placeholder="选择日期时间"
				      disabled
				      >
				    </el-date-picker>
				</li>
				<li style="width: 500px;">
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->是否允许APP充值</span>
					<el-radio v-model="app_pay" label="1">是</el-radio>
 					 <el-radio v-model="app_pay" label="0">否</el-radio>
				</li>
				<li>
					<span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->状态</span>
					<el-select v-model="status" placeholder="请选择" style="width: 200px;" disabled>
					    <el-option
					      v-for="item in statuss"
					      :key="item.id"
					      :label="item.value"
					      :value="item.id"
					      >
					    </el-option>
					  </el-select>
				</li>
				<li style="width: 400px;">
					<span class="add_Meter_Code_Name" style="width: 77px;"><!--<rt style="color:red;">*</rt>-->通断状态</span>
					<el-select v-model="power_status" placeholder="请选择" style="width: 200px;" disabled>
					    <el-option
					      v-for="item in statusd"
					      :key="item.id"
					      :label="item.value"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</li>
				<li><span class="add_Meter_Code_Name">楼号</span><el-input v-model="buildnum" placeholder="请输入楼号" style="width: 200px;" disabled></el-input></li>
				<li><span class="add_Meter_Code_Name">单元号</span><el-input v-model="unitnum" placeholder="请输入单元" style="width: 200px;" disabled></el-input></li>
				<li><span class="add_Meter_Code_Name" style="text-align: center;"><!--<rt style="color:red;">*</rt>-->门牌号</span>
					<el-input v-model="doornum" placeholder="请输入门牌号" style="width: 200px;" disabled></el-input></li>
				<li><span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->建筑面积</span>
					<el-input v-model="floor_area" placeholder="请输入建筑面积" style="width: 200px;" disabled></el-input></li>
				<li><span class="add_Meter_Code_Name"><!--<rt style="color:red;">*</rt>-->最大限额</span>
					<el-input v-model="quota" placeholder="请输入最大限额" style="width: 200px;"></el-input>
					<small style="display: block;margin-left: 10px;margin-top:5px; color:red;">{{type == '水表' ? '最大限额为正整数，>=2 且 <= 100 ,-1为不限制' : '最大限额为10的整数倍，<=1000 ，-1为不限制'}}</small>
				</li>
				<!--<li>
					<span class="add_Meter_Code_Name"><rt style="color:red;">*</rt>购买方式</span>
					<el-select v-model="buy_type" placeholder="请选择" style="width: 200px;">
					    <el-option
					      v-for="item in buyTypes"
					      :key="item.id"
					      :label="item.value"
					      :value="item.id">
					    </el-option>
					  </el-select>
				</li>-->
				<li><span class="add_Meter_Code_Name">备注</span>
					<el-input v-model="remark" placeholder="请输入需要备注的信息"  :rows="2"  type="textarea" style="width: 600px;"></el-input></li>
			</ul>
				<el-button type="primary" style="width:120px; margin-left: 330px;"
					@click="sumbit()">提交</el-button>
				<el-button @click="addMeterCodeClose" style="width: 120px;margin-bottom: 20px; margin-left: 30px;">关闭</el-button>
		</div>
	</div>
</template>

<script>
	export default{
		name:'change-code',
		props:['codeId', 'typess'],
		data(){
			return{
					account: '',
					code:'',
					nature:'',
					type:'',
					prop:'',
					rate:'',
					owner_name:'',
					owner_phone:'',
					owner_id_number:'',
					create_time:'',
					status:'',
					power_status:'',
					buildnum:'',
					unitnum:'',
					doornum:'',
					floor_area:'',
					buy_type:'',
					remark:'',
					quota:'',
					types:[
					/*
						{
							id: '0',
          					label: '电子电表'
						},
						{
							id: '1',
          					label: '智能电表'
						},*/
						{
							id: '7',
							label: '水表'
						},
						{
							id: '10',
          					label: '多功能单相'
						},
						{
							id: '11',
          					label: '多功能三相'
						}
					],
					natures:[],
					props:[
						{
							id:'',
							plan_name:'',
						}
					],
					rates:[
						{value:'1'},
						{value:'2'},
						{value:'3'},
						{value:'4'},
						{value:'5'},
						{value:'6'},
						{value:'8'},
						{value:'10'},
						{value:'15'},
						{value:'20'},
						{value:'30'},
						{value:'40'},
						{value:'50'},
						{value:'60'},
						{value:'80'},
						{value:'100'},
						{value:'120'},
						{value:'160'},
						{value:'200'},
						{value:'240'},
						{value:'320'},
						{value:'400'},
						{value:'600'},
						{value:'800'},
						{value:'1000'},
						{value:'1500'},
						{value:'2000'},
						{value:'3000'},
						{value:'4000'},
						{value:'5000'},
					],
					statuss:[
						{
							id:'0',
							value:'禁用',
						},
						{
							id:'1',
							value:'正常',
						}
					],
					statusd:[
						{
							id:'0',
							value:'断',
						},
						{
							id:'1',
							value:'通',
						}
					],
					buyTypes:[
						{
							id:'0',
							value:'贷款'
						},
						{
							id:'1',
							value:'全款'
						}
					],
					app_pay:'',
			}
		},
		created:function(){
			this.postprop()
			this.postChangeCode()
			this.natures = this.typess
		},
		watch:{
			// quota(val){
			// 	val
			// }
		},
		methods:{
			addMeterCodeClose(){
				this.$emit('Close')
			},
			postprop(){
				this.$jssdk.file.planList({},(data) =>{
					this.props = data.list
				})
			},
			postChangeCode(){
				this.$jssdk.file.info({meter_id:this.codeId},(data)=>{
					console.log('data',data);
					this.code=data.code
					this.account = data.account,
					this.type=data.type
					this.rate=data.rate
					this.prop=data.prop_id
					this.owner_name=data.owner_name
					this.owner_phone=data.owner_phone
					this.owner_id_number=data.owner_id_number
					this.create_time=data.create_time
					this.status=data.status
					this.power_status=data.power_status
					this.buildnum=data.buildnum
					this.unitnum=data.unitnum
					this.doornum=data.doornum
					this.floor_area=data.floor_area
					this.buy_type=data.buy_type
					this.remark=data.remark
					this.nature = data.nature
					this.app_pay = data.app_pay
					this.quota = data.quota
					if(data.buy_type === 0){
						this.buy_type = '贷款'
					}else{
						 this.buy_type = '全款'
					}
					if(data.type === 10){
						 this.type = '多功能单相'
					} else if(data.type === 7){
						this.type = '水表'
					}else{
						this.type = '多功能三相'
					}
				})
			},
			sumbit(){
				let code = this.code
				let type = this.type
				let prop = this.prop
				let nature = this.nature
				let rate = this.rate
				let name =this.owner_name
				let phone =this.owner_phone
				let num =this.owner_id_number
				let time = this.create_time
				let status =this.status
				let powerStatus=this.power_status
				let buildnum=this.buildnum
				let unitnum =this.unitnum
				let doornum=this.doornum
				let floorArea=this.floor_area
				let buyType=this.buy_type
				let remark=this.remark
				let meterId=this.codeId
				let appPay = this.app_pay
				let quota = this.quota
				// 验证额度管理
				quota = (quota == '-1' || quota == '' || quota == '0') ? '-1' : quota;
				if(quota.indexOf('.') != -1){
					return this.$message({
						type:'warning',
						message:'最大限额为正整数',
						duration:1000
					});
				}
				if(this.type == '水表' && quota != '-1'){
					if(quota < 2 || quota > 100){
						return this.$message({
							type:'warning',
							message:'最大限额不得小于2 并不得大于100',
							duration:1000
						});
					}
				} else if(this.type != '水表' && quota != '-1') {
					if(quota % 10 != 0 || quota > 1000){
						return this.$message({
							type:'warning',
							message:'最大限额需为10的倍数 并不得大于1000',
							duration:1000
						});
					}
				}
				/*if(code.length != 12){
					return this.$message({
						type:'warning',
						message:'请输入完整电表号',
						duration:1000
					})
				}*/
				if(this.owner_phone && this.owner_phone.length < 7){
					return this.$message({
						type:'warning',
						message:'业主电话必须是7-11位',
						duration:1000
					})
				}
				if(this.owner_id_number && this.owner_id_number.length < 18) {
					return this.$message({
						type:'warning',
						message:'请输入完整身份证号',
						duration:1000
					})
				}
				if(this.buy_type === '贷款'){
						buyType = '0'
					}else{
						 buyType = '1'
					}
					console.log(type)
				if(this.type === '多功能单相' || this.type ==='10'){
						type = '10'
					}else{
						type = '11'
				}
					
				this.$jssdk.file.edit({
					meter_id:meterId,
					code:code,type:type,prop:prop,rate:rate,
					owner_name:name,owner_phone:phone,owner_id_number:num,
					create_time:time,status:status,power_status:powerStatus,
					buildnum:buildnum,unitnum:unitnum,doornum:doornum,floor_area:floorArea,
					buy_type:buyType,remark:remark,nature:nature,app_pay:appPay,
					quota:quota
				},(data)=>{
					this.$message({
						type:'success',
						message:'修改成功',
						duration:1000
					})
					this.$emit('Close')
				},(err)=>{
					this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
		},
	}
</script>

<style scoped>
	.bg_add{
		background-color: rgba(0,0,0,.7);
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 6;
	}
	.addMeterCode{
		position: absolute;
		top: 50%;
		left: 50%;
		height: 90%;
		transform: translate(-50%, -50%);
		background: #fff;
		width: 900px;
		overflow: hidden;
		overflow-y: auto;
		border:2px solid #8fceff;
		border-radius: 10px;
		box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	}
.add_Meter_Code_Name{
	display: inline-block;
	width: 75px;
}
.addMeterCode ul{
	overflow:hidden;
	list-style: none;
	padding: 0;
	margin-left: 10px;
}
.addMeterCode ul li{
	float: left;
	font-size: 14px;
	margin: 20px 12px  7px  7px !important;
	
}
.addMeterCode ul li:nth-child(1){
	width: 400px;
}
.addMeterCode ul li:last-child{
	line-height: 50px;
	height: 50px;
}
</style>


// WEBPACK FOOTER //
// changeCode.vue?5f9fe741